import { FieldArray, FieldArrayRenderProps } from "formik"
import { Button, Card, Col, Row } from "react-bootstrap"
import { DragDropVertical } from "../../DragDrop/DragDropVertical"
import FieldGenerator, { FieldGeneratorFieldType } from "../FieldGenerator/FieldGenerator"

export const ArrayFieldInput = (props: {
  fieldName: string,
  values: any[],
  touched?: any,
  errors?: any,
  setFieldValue: (f: string, v: any[]) => void,
  fields: FieldGeneratorFieldType[],
  blankEntryFn: () => any,
  customClass?: string,
  imgPreview?: { srcVal: string }
  uploadImageFn?: (file: File) => Promise<any>,
  // uploadImageMultiFn?: (files: File[]) => Promise<any>,
}) => {
  const {
    fieldName,
    values,
    setFieldValue,
    fields,
    blankEntryFn,
    customClass,
    imgPreview,
    // touched,
    // errors,
    uploadImageFn,
    // uploadImageMultiFn
  } = props

  return (
    <div className="field-container">
      <FieldArray
        key={fieldName}
        name={fieldName}
        render={(arrayHelpers: FieldArrayRenderProps) => (
          <div className="field-array-container">
            {/* {values && values.length === 0 && (
              <p>No entries. Click below to add one.</p>
            )} */}
            <DragDropVertical
              idBase={fieldName}
              valuesArray={values}
              customClass={customClass}
              onReorder={(newValues: any[]) => {
                setFieldValue(fieldName, [...newValues])
              }}
              childRenderer={(item: { entry: any, idx: number }) => {
                const hasImagePreviewValue = imgPreview && item.entry[imgPreview.srcVal]
                return (
                  <Card>
                    <Card.Body>
                      <div className="field-array-entry">
                        <div className={`drag-entry ${hasImagePreviewValue ? 'has-image' : ''}`}>
                          {imgPreview && item.entry[imgPreview.srcVal] && (
                            <div className="drag-image-preview">
                              <img className="image-preview" src={item.entry[imgPreview.srcVal]} alt={`${fieldName} preview ${item.idx}`} />
                            </div>
                          )}
                          {/* {imgPreview && !item.entry[imgPreview.srcVal] && (
                            <div className="drag-image-preview">
                              <p>Image Source Missing</p>
                            </div>
                          )} */}
                          <div className="drag-fields-container">
                            <Row>
                              {fields.map((fieldEntry: any, idx: number) => {
                                const {
                                  layout = { xs: 12 },
                                  condition = (values: any) => true,
                                } = fieldEntry

                                if (!condition(item.entry)) {
                                  return null
                                }

                                return (
                                  <Col key={`${fieldName}-array-entry-${idx}`} className="field-wrapper" {...layout}>
                                    <FieldGenerator
                                      {...fieldEntry}
                                      uploadImageFn={fieldEntry.fieldType === 'imageUpload' && uploadImageFn ? uploadImageFn : undefined}
                                      fieldName={`${fieldName}[${item.idx}].${fieldEntry.fieldName}`} />
                                  </Col>
                                )
                              })}
                            </Row>
                          </div>
                        </div>
                        <Button
                          className="remove-btn array-btn"
                          // className="remove-btn array-btn mb-3"
                          type="button"
                          size="sm"
                          variant="danger"
                          onClick={() => arrayHelpers.remove(item.idx)}>
                          - Remove
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                )
              }}
            />
            {values && values.length > 0 && (
              <br />
            )}
            <Button
              className="add-btn array-btn mb-3"
              type="button"
              size="sm"
              onClick={() => arrayHelpers.push(blankEntryFn())}>
              + Add
            </Button>
          </div>
        )}
      />
    </div>
  )
}
